// extracted by mini-css-extract-plugin
export var container = "EventProgram-module--container--1eb86";
export var layout = "EventProgram-module--layout--65e5e";
export var subtitle = "EventProgram-module--subtitle--1c36e";
export var itemsWrapper = "EventProgram-module--itemsWrapper--81cf1";